import React from 'react';
import '../../styles/common/AdminPageContent.css';

const AdminPageContent = ({ 
  children,
  loading = false,
  error = null,
  emptyState = null,
  className = ''
}) => {
  if (loading) {
    return (
      <div className={`admin-page-content loading ${className}`}>
        <div className="loading-state">
          <div className="loading-spinner"></div>
          <p>Loading...</p>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={`admin-page-content error ${className}`}>
        <div className="error-state">
          <p>{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className={`admin-page-content ${className}`}>
      {React.Children.count(children) > 0 ? children : emptyState}
    </div>
  );
};

export default AdminPageContent;
